module.exports = __webpack_public_path__ + "AvertaStd-Black.svg?1f88e625c60d10ca4132a2394da9575f";